<div class="container">
  <div class="row">
    <div class="col-12">
      <img
        src="https://foxpost.hu/img/page-500-bg-img.svg"
        class="d-block mx-auto w-75"
      />
    </div>
    <div class="col-12 text-center">
      <h1 class="foxpost-title">An error has occurred (#500)</h1>
    </div>
    <div class="col-12 text-center">
      <a mat-flat-button href="/" class="primary-btn">Vissza a főoldalra</a>
    </div>
  </div>
</div>
